/**
 *
 * RoomTSFilter
 *
 */

import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';
import { RoomTSPicker } from 'app/components/pickers/AutocompletePickers/RoomTSPicker';

export const RoomTSFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<string> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <RoomTSPicker
      onChange={handleOnChange}
      value={props.value as Entity<string> | undefined | null}
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
      ariaLabel={props.label}
      size="small"
      id={props.id}
    />
  );
};
export default RoomTSFilter;
